module.exports = __webpack_public_path__ + "img/tip_3.95af79bb.png";